import {
    LOANREQUEST_STATUS_REASONS,
    LOANREQUEST_STATUSES,
    MAIL_FAILURE_REASONS,
    STATUS_MAIL_PREVIEW_KINDS,
} from 'cpool-constants';
import { z } from 'zod';

import { schemaApproved } from '../../LoanRequest/status/discriminatedUnions/approved';
import { schemaInitial } from '../../LoanRequest/status/discriminatedUnions/initial';
import { schemaInProgress } from '../../LoanRequest/status/discriminatedUnions/inProgress';
import { schemaOfferAtBank } from '../../LoanRequest/status/discriminatedUnions/offerAtBank';
import { schemaOfferAtCustomer } from '../../LoanRequest/status/discriminatedUnions/offerAtCustomer';

export const statusMailPreviewRequest = z.discriminatedUnion('status', [
    schemaInitial.pick({ status: true, subStatus: true }),
    schemaInProgress.pick({ status: true, subStatus: true }),
    schemaOfferAtCustomer.pick({ status: true, subStatus: true }),
    schemaOfferAtBank.pick({ status: true, subStatus: true }),
    schemaApproved.pick({ status: true, subStatus: true }),
    z.object({
        status: z.literal(LOANREQUEST_STATUSES.CANCELED),
        statusReason: z.array(z.nativeEnum(LOANREQUEST_STATUS_REASONS)).min(1),
    }),
]);

export type StatusMailPreviewRequest = z.infer<typeof statusMailPreviewRequest>;

export const statusMailPreviewResponse = z.discriminatedUnion('kind', [
    z.object({
        html: z.string(),
        kind: z.literal(STATUS_MAIL_PREVIEW_KINDS.PREVIEW),
        subject: z.string(),
        text: z.string(),
    }),
    z.object({
        kind: z.literal(STATUS_MAIL_PREVIEW_KINDS.NO_TEMPLATE),
        reason: z.nativeEnum(MAIL_FAILURE_REASONS),
    }),
    z.object({ kind: z.literal(STATUS_MAIL_PREVIEW_KINDS.NO_MAIL) }),
    z.object({
        kind: z.literal(STATUS_MAIL_PREVIEW_KINDS.NOT_SENDABLE),
        reason: z.nativeEnum(MAIL_FAILURE_REASONS),
    }),
]);

export type StatusMailPreviewResponse = z.infer<typeof statusMailPreviewResponse>;
